/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Replace_ButtonInputs */



/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Find_Replace_Replace_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_replace_button = /** @type {((inputs?: Find_Replace_Replace_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Replace_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ersetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заменять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代替")
	if (locale === "ja") return /** @type {LocalizedString} */ ("交換する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिस्थापित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substituir")
	return /** @type {LocalizedString} */ ("Replace")
});